/** @prettier */
import { CHANGE_PRODUCT } from '@xanadu/ui-shared/modules/application/actions';

import { PINNED_BETSLIP_CONFIGURATION } from '../../constants';

import { all, put, takeEvery } from 'redux-saga/effects';

import { togglePinning } from './actions';

function* handleProductChanges({ payload: product }) {
  yield put(togglePinning(PINNED_BETSLIP_CONFIGURATION[product]));
}

export default function* root() {
  yield all([takeEvery(CHANGE_PRODUCT, handleProductChanges)]);
}
